import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IContractorAdditionalInfo extends IModel {
	name?: string;
	value?: string;
}

const contractorAdditionalInfoFactory = modelFactory.createFactory<IContractorAdditionalInfo>('ContractorAdditionalInfo', _.assign({}, model, {
	name: {
		rules: validator.string()
	},
	value: {
		setFilters: valueFilters.toString,
		rules: validator.string()
	}
}));

export default contractorAdditionalInfoFactory;